import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-row items-center hidden sm:flex" }
const _hoisted_2 = { class: "opacity-70" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mx-1" }, "to", -1)
const _hoisted_4 = { class: "opacity-70" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getDisplayName(_ctx.tx.origin_domain_id)), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getDisplayName(_ctx.tx.destination_domain_id)), 1)
  ]))
}